import {
  COGNITO_APP_CLIENT_ID,
  COGNITO_DOMAIN,
  COGNITO_REDIRECT_URI,
  COGNITO_USER_POOL_ID,
} from '@Env/variables';
import { Amplify } from 'aws-amplify';
import { signInWithRedirect } from 'aws-amplify/auth';

export const initAuth = () => {
  const redirect = COGNITO_REDIRECT_URI + '/auth/callback';
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: COGNITO_USER_POOL_ID,
        userPoolClientId: COGNITO_APP_CLIENT_ID,
        loginWith: {
          oauth: {
            domain: COGNITO_DOMAIN,
            scopes: [
              'email',
              'profile',
              'openid',
              'principal/employee',
              'aws.cognito.signin.user.admin',
            ],
            redirectSignIn: [redirect],
            redirectSignOut: [COGNITO_REDIRECT_URI],
            responseType: 'code',
          },
        },
      },
    },
  });
};

export const signInWithAzureAD = async () => {
  await signInWithRedirect({
    provider: { custom: 'azure-ad' },
  });
};
